import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import TableContainer from "../../Components/Common/TableContainer";
import { Col, Row, Card, CardBody } from "reactstrap";
import Spinners from "Components/Common/Spinner";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { useDeleteExpense, useGetExpenses } from "hooks/useExpenses";
import CellActions from "../../Components/CellActions";
import { readableDate } from "utils";
import { AppRoutes } from "../../constants";
import ExpenseDetail from "./ExpenseDetails";

function Expenses() {
  document.title = "Papermap | Expenses";
  const navigate = useNavigate();
  const { mutate: deleteExpense } = useDeleteExpense();
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [resource, setResource] = useState<any>(null);
  const [selectedExpense, setSelectedExpense] = useState<any>("");
  const [viewModal, setViewModal] = useState<boolean>(false);

  const { data, isLoading } = useGetExpenses();

  const handleAddExpenseClick = () => {
    navigate(AppRoutes.CREATE_EXPENSE);
  };

  const toggle = () => {
    setViewModal(!viewModal);
  };

  const onClickDelete = (item: any) => {
    setResource(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (resource) {
      await deleteExpense(resource.id); // Call the delete function
      setDeleteModal(false);
      setResource(null); // Clear the selected resource
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "Expense ID",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        className: "d-flex align-items-center justify-content-center",
      },
      {
        header: "Category",
        accessorKey: "category.name",
        enableColumnFilter: false,
        enableSorting: true,
        className: "d-flex align-items-center justify-content-center",
      },
      {
        header: "Amount",
        accessorKey: "amount",
        enableColumnFilter: false,
        enableSorting: true,
        className: "d-flex align-items-center justify-content-center  m-0 mb-0",
        cell: (cellProps: any) => (
          <p style={{ margin: "0", padding: "0" }}>
            {cellProps.row.original.amount.toFixed(2)}
          </p>
        ),
      },
      {
        header: "Created by",
        accessorKey: "created_by_user.email",
        enableColumnFilter: false,
        enableSorting: true,
        className: "d-flex align-items-center justify-content-center m-0",
      },
      {
        header: "Date created",
        accessorKey: "date",
        enableColumnFilter: false,
        enableSorting: true,
        className: "d-flex align-items-center justify-content-center p-3",
        cell: (cellProps: any) => (
          <p style={{ margin: "0", padding: "0" }}>
            {cellProps.row.original.amount.toFixed(2)}
          </p>
        ),
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: true,
        className: "text-left pt-4",
        cell: (cellProps: any) => (
          <CellActions
            onView={async () => {
              await setSelectedExpense(cellProps.row.original);
              console.log(selectedExpense);
              toggle();
            }}
            data={cellProps.row.original}
            onEdit={`/edit-expense/${cellProps.row.original.id}`}
            onDelete={(data) => onClickDelete(data)}
          />
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <ExpenseDetail
        isOpen={viewModal}
        toggle={toggle}
        expense={selectedExpense}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteConfirm}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Expenses" breadcrumbItem="View Expenses" />
          {isLoading ? (
            <Spinners />
          ) : (
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    <TableContainer
                      columns={columns}
                      data={data || []}
                      isGlobalFilter={true}
                      isAddButton={true}
                      isCustomPageSize={true}
                      handleUserClick={handleAddExpenseClick}
                      isPagination={true}
                      SearchPlaceholder="Search..."
                      buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2 addBranch-modal"
                      buttonName="Add New Expense"
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Expenses;
